import { render, staticRenderFns } from "./BackupHealthAttorneysYN.vue?vue&type=template&id=1f7f9b22"
import script from "./BackupHealthAttorneysYN.vue?vue&type=script&lang=js"
export * from "./BackupHealthAttorneysYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports